import { combineReducers } from "redux";

import itemsReducer from "./itemsReducer";
import feedbackReducer from "./feedbackReducer";
import userReducer from "./userReducer";
import quizzesReducer from "./quizzesReducer";
import questionsReducer from "./questionsReducer";
import profileNamesReducer from "./profileNamesReducer";
import organizationProfileReducer from "./organizationProfileReducer";
import reportsReducer from "./reportsReducer";
import weaknessesReducer from "./weaknessesReducer";
import assetsReducer from "./assetsReducer";
import useCaseReducer from "./useCaseReducer";
import risksReducer from "./risksReducer";
import usersManagementReducer from "./usersManagementReducer";
import iconsReducer from "./iconsReducer";
import forwardReducer from "./forwardReducer";
import tagsReducer from "./tagsReducers";
import avatarsReducer from "./avatarsReducer";
import notificationsReducer from "./notificationsReducer";
import LinkOrgaReducer from "./linkOrgaReducer";
import confirmInvitationReducer from "./confirmInvitationReducer";
import tabManagementReducer from "./tabManagementReducer";
import messageReducer from "./chatReducer";
import dashboardReducer from "./dashboardReducer";
import workstationReducer from "./workstationReducer";
import evaluationReducer from "./evaluationReducer";
import threatLandscapeReducer from "./threatLandscapeReducer";
import businessFunctionsReducer from "./businessFunctionsReducer";
import assetInventoryReducer from "./assetInventory";
import riskScenariosReducer from "./riskScenariosReducer";
import riskAssessmentReducer from "./riskAssessmentReducer";

const rootReducer = combineReducers({
  items: itemsReducer,
  feedback: feedbackReducer,
  user: userReducer,
  quizzes: quizzesReducer,
  questions: questionsReducer,
  profileNames: profileNamesReducer,
  organizationProfile: organizationProfileReducer,
  reports: reportsReducer,
  assets: assetsReducer,
  weaknesses: weaknessesReducer,
  useCase: useCaseReducer,
  risks: risksReducer,
  users: usersManagementReducer,
  icons: iconsReducer,
  forwardQuiz: forwardReducer,
  tags: tagsReducer,
  avatars: avatarsReducer,
  notifications: notificationsReducer,
  linkOrga: LinkOrgaReducer,
  confirmInvitation: confirmInvitationReducer,
  tabManagement: tabManagementReducer,
  message: messageReducer,
  dashboard: dashboardReducer,
  workstation: workstationReducer,
  evaluation: evaluationReducer,
  threatLandscape: threatLandscapeReducer,
  businessFunctions: businessFunctionsReducer,
  assetInventory: assetInventoryReducer,
  riskScenarios: riskScenariosReducer,
  riskAssessment: riskAssessmentReducer,
});

export default rootReducer;
